export * from './configuration';
export * from './remoteConfiguration';
//# sourceMappingURL=index.js.map